/**
 * @description tab
 */

import { setMatchHeight } from '../common/setMatchHeight';

export const setTab = () => {
  $('.js-tab-trigger').on('click', (e) => {
    const tabWrap = $(e.currentTarget).parents('.tab-wrapper');
    const tabBtn = tabWrap.find('.js-tab-trigger');
    const tabContents = tabWrap.find('.tab-contents');
    tabBtn.removeClass('on');
    $(e.currentTarget).addClass('on');
    const elmIndex = tabBtn.index($(e.currentTarget));
    tabContents.removeClass('is-show');
    tabContents.eq(elmIndex).addClass('is-show');
    setMatchHeight();
  });
};
